import React from "react";
import {
  AuthBar,
  AuthLabel,
  AuthButton,
  SaveStatus,
} from "./CareerPath.styles";

const PublicProfileToggle = ({
  profilePublic,
  copyHint,
  emailMuted,
  onTogglePublic,
  onCopyShareLink,
  onToggleEmailMute,
}) => (
  <AuthBar>
    <AuthLabel>
      Profile visibility: {profilePublic ? "PUBLIC" : "PRIVATE"}
      {copyHint && <SaveStatus>{copyHint}</SaveStatus>}
    </AuthLabel>
    <AuthButton onClick={onTogglePublic}>
      {profilePublic ? "MAKE PRIVATE" : "MAKE PUBLIC"}
    </AuthButton>
    {profilePublic && (
      <AuthButton onClick={onCopyShareLink}>COPY SHARE LINK</AuthButton>
    )}
    <AuthLabel>Email notifications: {emailMuted ? "OFF" : "ON"}</AuthLabel>
    <AuthButton onClick={onToggleEmailMute}>
      {emailMuted ? "TURN ON" : "MUTE ALL"}
    </AuthButton>
  </AuthBar>
);

export default PublicProfileToggle;
